import React, { FC } from 'react'
import { StyledContainer, StyledText, ImageContainer } from './styles'
import NextImage from 'next/image'
import { defaultLoader } from '../../../../../utils/imageLoaders'
import getDomainName from '../../../../../utils/getDomainName'

type AreasItemProps = {
  icon: string
  text: string
}

const AreasItem: FC<AreasItemProps> = ({ icon, text }) => {
  const domain = getDomainName()
  return (
    <StyledContainer>
      <ImageContainer>
        <NextImage
          loader={defaultLoader}
          src={`${domain}/hermes-static/icons/${icon}.svg`}
          alt=""
          width={22}
          height={22}
          objectFit="none"
        />
      </ImageContainer>
      <StyledText>{text}</StyledText>
    </StyledContainer>
  )
}

export default AreasItem
